import { InjectionToken } from '@angular/core'

export const REQUEST_HOST = new InjectionToken<string>('REQUEST_HOST')
